module.exports = __webpack_public_path__ + "static/media/download.fb039775.svg";